// FILE: src/app/(public)/error.tsx
// VERSION: 1.0.0
// START_MODULE_CONTRACT:
// PURPOSE: Глобальный Error Boundary для публичных страниц (guard-portal, questionnaire, e/, c/).
// SCOPE: (public) — нейтральная тема
// INPUT: Error объект из Next.js Error Boundary
// OUTPUT: UI с предложением повторить попытку
// KEYWORDS: DOMAIN(ErrorBoundary); CONCEPT(PublicPages, ErrorHandling)
// LINKS: USES_API(Next.js ErrorBoundary); USES_API(lucide-react AlertTriangle)
// END_MODULE_CONTRACT

'use client';

import { useEffect } from 'react';
import { Button } from '@oxpa/shared/ui/button';
import { AlertTriangle } from 'lucide-react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[Public Error]', error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] gap-4 p-8">
      <div className="rounded-full bg-destructive/10 p-4">
        <AlertTriangle className="w-8 h-8 text-destructive" />
      </div>
      <h2 className="text-xl font-bold text-foreground">Что-то пошло не так</h2>
      <p className="text-muted-foreground text-sm max-w-md text-center">
        Произошла ошибка при загрузке страницы. Попробуйте обновить страницу.
      </p>
      <Button onClick={() => reset()} variant="default">
        Попробовать снова
      </Button>
    </div>
  );
}
